export const getStorageToken = () => window.localStorage.getItem('token')

export const setStorageToken = token => window.localStorage.setItem('token', token)